export const SET_THEME = "SET_THEME";
export const SET_LOGO = "SET_LOGO";
export const SET_CLIENT_IDS = "SET_CLIENT_IDS";
export const SET_LINKS = "SET_LINKS";
